export default __webpack_public_path__ + "static/media/house.b3c5e47d.png";